/** Accept official channel links only; never fall back to a customer-service URL. */
export const getWhatsAppChannelUrl = (value: unknown): string | null => {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const url = new URL(value.trim());
    if (
      url.protocol !== "https:" ||
      !["whatsapp.com", "www.whatsapp.com"].includes(url.hostname) ||
      url.username || url.password || url.port ||
      !/^\/channel\/[a-zA-Z0-9]+\/?$/.test(url.pathname)
    ) return null;
    return url.href;
  } catch {
    return null;
  }
};
